// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__h0mas","inputWrap":"styles_inputWrap__jl3S3","input":"styles_input__3YK5r"};